import { CSSProperties } from "react";

interface ButtonLoaderProps {
  size?: number;
  speed?: number;
  thickness?: number;
  glowIntensity?: number;
  className?: string;
  style?: CSSProperties;
  color?: string;
}

const ButtonLoader: React.FC<ButtonLoaderProps> = ({
  size = 20,
  speed = 1,
  thickness = 3,
  glowIntensity = 8,
  className = "",
  style = {},
  color = "white",
}) => {
  const spinnerSize = `${size}px`;
  const animationDuration = `${1.2 / speed}s`;
  const borderWidth = `${thickness}px`;
  const glowSize = `${glowIntensity}px`;

  // Use color for borderTop and boxShadow
  const spinnerStyle: CSSProperties = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: spinnerSize,
    height: spinnerSize,
    border: `${borderWidth} solid transparent`,
    borderTop: `${borderWidth} solid ${color}`,
    borderRadius: "50%",
    animation: `spin ${animationDuration} linear infinite`,
    boxShadow: `0 0 ${glowSize} ${color}, inset 0 0 ${glowSize} ${color}80`,
    ...style,
  };

  return (
    <>
      <style>{`
        @keyframes spin {
          0% { transform: translate(-50%, -50%) rotate(0deg); }
          100% { transform: translate(-50%, -50%) rotate(360deg); }
        }
      `}</style>
      <div
        className={className}
        style={spinnerStyle}
      />
    </>
  );
};

export default ButtonLoader;